var _desc, _defs, _rect, _path, _path2, _path3, _rect2, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductStorefrontTakis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Takis") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A purple snack bag for Takis.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "takis-bag",
    x1: 73,
    y1: 34,
    x2: 167,
    y2: 220,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b21b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#91011e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b23212"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    rx: 24,
    fill: "#fff7f5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 36c26 12 68 12 94 0l-9 169c-24 15-52 15-76 0L73 36Z",
    fill: "url(#takis-bag)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 36c26 12 68 12 94 0l-4 29c-24 10-62 10-86 0L73 36Z",
    fill: "#2e1065",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83 204c24 15 52 15 76 0l-2 21c-24 10-49 10-72 0l-2-21Z",
    fill: "#6f0017"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 84,
    width: 72,
    height: 50,
    rx: 10,
    fill: "#ffffff",
    opacity: 0.94
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96 105h48M96 121h39",
    fill: "none",
    stroke: "#5b21b6",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101 157c11-15 26-11 34 2 7-6 18-5 25 4",
    fill: "none",
    stroke: "#f6a33c",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100 178c14-8 31-8 46 0",
    fill: "none",
    stroke: "#ffd166",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53c18 7 41 7 59 0",
    fill: "none",
    stroke: "#fff7f5",
    strokeWidth: 5,
    strokeLinecap: "round",
    opacity: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductStorefrontTakis);
export default __webpack_public_path__ + "static/media/product_storefront_takis.71ca23cef02ada07db85949e22943afd.svg";
export { ForwardRef as ReactComponent };